<div class="divHome">
  <div class="divButtons">
    <div class="top-controls">
      <div class="search-box">
        <i-tabler name="search" class="search-icon"></i-tabler>
        <input
          type="text"
          placeholder="Buscar"
          [(ngModel)]="searchQuery"
          (keyup)="applyFilters()"
        />
      </div>
      <div class="action-actions">
        <button
          mat-stroked-button
          class="actualizar-btn"
          (click)="refreshData()"
        >
          <i-tabler name="refresh" class="btn-icon"></i-tabler> Actualizar
        </button>
        <button
          mat-stroked-button
          class="filtros-btn"
          (click)="toggleFilters()"
        >
          <i-tabler name="filter" class="btn-icon"></i-tabler> Filtros
        </button>
      </div>
    </div>

    <div class="filters-panel" *ngIf="showFilters">
      <div class="filter-column">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <label class="filter-label">Fecha de Creación</label>
          <a
            style="
              cursor: pointer;
              font-size: 12px;
              color: #ef4444;
              text-decoration: underline;
            "
            *ngIf="filterDate"
            (click)="filterDate = null; applyFilters()"
            >Quitar</a
          >
        </div>
        <mat-form-field appearance="outline" class="filter-field">
          <input
            matInput
            [matDatepicker]="picker"
            [(ngModel)]="filterDate"
            (dateChange)="applyFilters()"
            placeholder="DD/MM/YYYY"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Tipo de Revisión</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(ngModel)]="filterReviewType"
            (selectionChange)="applyFilters()"
            placeholder="Seleccionar"
          >
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let option of reviewTypes" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Destino</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(ngModel)]="filterDestination"
            (selectionChange)="applyFilters()"
            placeholder="Seleccionar"
          >
            <mat-option value="">Todos</mat-option>
            <mat-option
              *ngFor="let option of destinationOptions"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-column">
        <label class="filter-label">Estado de Revisión</label>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select
            [(ngModel)]="filterStatus"
            (selectionChange)="applyFilters()"
            placeholder="Seleccionar"
          >
            <mat-option value="">Todos</mat-option>
            <mat-option
              *ngFor="let option of statusOptions"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <p class="results-text">
    <i-tabler name="info-circle" class="info-icon"></i-tabler>
    Se encontraron {{ csReviewDataSource.filteredData.length || 0 }} Revisión de
    Biblia
  </p>

  <div class="table-container">
    <div class="loading-overlay" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ loadingMessage }}</p>
    </div>

    <div class="error-message" *ngIf="hasError">
      <i-tabler name="alert-triangle"></i-tabler>
      <p>Error al cargar las revisiones. Por favor, intenta de nuevo.</p>
      <button mat-button color="primary" (click)="refreshData()">
        Reintentar
      </button>
    </div>

    <table
      mat-table
      [dataSource]="csReviewDataSource"
      matSort
      class="pre-operativas-table"
    >
      <ng-container matColumnDef="incidentDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Fecha de<br />Revisión
        </th>
        <td mat-cell *matCellDef="let preOpIncident">
          {{ preOpIncident.incidentDate | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="isApproved">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Tipo de <br />Revisión
        </th>
        <td mat-cell *matCellDef="let preOpIncident">
          {{
            preOpIncident.incidentStatus === this.INCIDENT_STATUS.APPROVED
              ? "Aprobado"
              : "Regularizar"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="fileNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>File</th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div class="wrap-cell">{{ preOpIncident.fileNumber }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="nameClient">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div class="wrap-cell">{{ preOpIncident.nameClient }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="fileProgrammer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Programador</th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div class="wrap-cell">{{ preOpIncident.fileProgrammer }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Destino</th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div class="destination-badge" *ngIf="preOpIncident.destination">
            <i-tabler name="map-pin" class="dest-icon"></i-tabler>
            <span class="dest-text">{{
              preOpIncident.destination | titlecase
            }}</span>
          </div>
          <span *ngIf="!preOpIncident.destination">-</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Descripción de Incidencia
        </th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div class="description-cell">{{ preOpIncident.description }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="incidentStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-status">
            Estado de<br />Incidencia
            <i-tabler name="help" class="help-icon"></i-tabler>
          </div>
        </th>
        <td mat-cell *matCellDef="let preOpIncident">
          <div
            class="status-badge"
            [ngClass]="{
              'status-pending':
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.PENDING,
              'status-resolved':
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.RESOLVED,
              'status-not-resolved':
                preOpIncident.incidentStatus ===
                this.INCIDENT_STATUS.NOT_APPROVED,
              'status-approved':
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.APPROVED
            }"
          >
            <ng-container
              *ngIf="
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.PENDING
              "
              >Creado</ng-container
            >
            <ng-container
              *ngIf="
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.RESOLVED
              "
              >Resuelto por Prog.</ng-container
            >
            <ng-container
              *ngIf="
                preOpIncident.incidentStatus ===
                this.INCIDENT_STATUS.NOT_APPROVED
              "
              >No Aprobado</ng-container
            >
            <ng-container
              *ngIf="
                preOpIncident.incidentStatus === this.INCIDENT_STATUS.APPROVED
              "
              >Aprobado</ng-container
            >
            <ng-container
              *ngIf="
                ![
                  this.INCIDENT_STATUS.PENDING,
                  this.INCIDENT_STATUS.RESOLVED,
                  this.INCIDENT_STATUS.NOT_APPROVED,
                  this.INCIDENT_STATUS.APPROVED
                ].includes(preOpIncident.incidentStatus)
              "
            >
              {{ preOpIncident.incidentStatus }}
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="details" stickyEnd="true">
        <th mat-header-cell *matHeaderCellDef class="table-actions-col">
          Detalles
        </th>
        <td mat-cell *matCellDef="let preOpIncident" class="table-actions-col">
          <button
            mat-icon-button
            class="action-button"
            (click)="openIncidentsHistorial(preOpIncident)"
          >
            <i-tabler name="dots-vertical" class="action-icon"></i-tabler>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row empty-row" *matNoDataRow>
        <td
          class="mat-cell"
          [attr.colspan]="displayedColumns.length"
          *ngIf="!isLoading && !hasError"
        >
          No se encontraron resultados para "{{ searchQuery }}" u otros filtros.
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
    aria-label="Seleccionar página de incidencias"
  ></mat-paginator>

  <div class="legend-card">
    <h3>Leyenda de Estado de Revisión de Atención al Cliente</h3>
    <div class="legend-items">
      <div class="legend-item">
        <span class="legend-badge status-pending">Creado</span>
        <span class="legend-label"
          >La revisión se realizó en Biblia por Atención al Clientey se puede
          visualizar en Operaciones &#8594; Programación de files.</span
        >
      </div>
      <div class="legend-item">
        <span class="legend-badge status-resolved">Resuelto por Prog.</span>
        <span class="legend-label"
          >La observación fue resuelta por la programadora y está a la espera de
          la aprobación de la Atención al Cliente.</span
        >
      </div>
      <div class="legend-item">
        <span class="legend-badge status-approved">Aprobado</span>
        <span class="legend-label"
          >Atención al Cliente está de acuerdo con la solución realizada por la
          programadora.</span
        >
      </div>
      <div class="legend-item">
        <span class="legend-badge status-not-resolved">No Aprobado</span>
        <span class="legend-label"
          >No se aprobó la observación por Atención al Cliente, la programadora
          necesita volver a revisar la información.</span
        >
      </div>
    </div>
  </div>
</div>
